import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButtonGroup as ToggleGroup } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { Button } from '../../atoms/Button';
export function ToggleButtonGroup({ data, selectedOption, handleSelectedOption, maxWidth, disabled, }) {
    const { t } = useTranslation();
    const [format, setFormat] = useState([]);
    return (_jsx(ToggleGroup, { disabled: disabled, sx: () => ({
            maxWidth,
            width: '100%',
            '& .MuiButton-text': {
                backgroundColor: '#FFFFFF',
                height: 'fit-content',
                width: 'fit-content',
            },
        }), value: format, children: data.map(({ value, translationKey }) => (_jsx(Button, { onClick: (_) => {
                handleSelectedOption(value);
                setFormat([value]);
            }, variant: selectedOption === value ? 'contained' : 'text', value: typeof value === 'string' ? value : undefined, children: t(translationKey) }, typeof value === 'string' ? value : undefined))) }));
}
